function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "primary/play",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M0.5983887,28.595424 C0.4685052,28.595424 0.3571782,28.5628455 0.26440425,28.4976885 C0.08813385,28.395297 0,28.22775 0,27.9950445 L0,0.6009615 C0,0.368256 0.08813385,0.200709 0.26440425,0.098319 C0.44995215,-0.022689 0.649413,-0.0319965 0.86279295,0.0703935 L28.1660157,13.767435 C28.388673,13.869825 28.5,14.0466795 28.5,14.298003 C28.5,14.5493265 28.388673,14.726181 28.1660157,14.828571 L0.86279295,28.5256125 C0.7514643,28.5721545 0.66333045,28.595424 0.5983887,28.595424 Z",
  id: "play-copy"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    version: 1.1
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/play-icon.6e6ad57e.svg";
export { SvgComponent as ReactComponent };